import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

function upsertMetaByName(name, content) {
  if (!content) return;
  let tag = document.head.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function upsertMetaByProperty(property, content) {
  if (!content) return;
  let tag = document.head.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let link = document.head.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

function upsertJsonLd(id, data) {
  if (!data) return;
  const scriptId = `jsonld-${id}`;
  let script = document.getElementById(scriptId);
  if (!script) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = scriptId;
    document.head.appendChild(script);
  }
  script.text = JSON.stringify(data);
}

export default function SEO({ title, description, canonical, type = 'website' }) {
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    // html lang
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', currentLanguage === 'japanese' ? 'ja' : 'en');
    }

    // Title
    if (title) {
      document.title = title;
      upsertMetaByProperty('og:title', title);
      upsertMetaByName('twitter:title', title);
    }

    // Description
    if (description) {
      upsertMetaByName('description', description);
      upsertMetaByProperty('og:description', description);
      upsertMetaByName('twitter:description', description);
    }

    // Canonical
    const url = canonical || (typeof window !== 'undefined' ? window.location.href : undefined);
    if (url) {
      upsertLink('canonical', url);
      upsertMetaByProperty('og:url', url);
    }

    // Types and basics
    upsertMetaByProperty('og:type', type);
    upsertMetaByProperty('og:site_name', 'FrontPlay');
    upsertMetaByName('twitter:card', 'summary_large_image');

    // JSON-LD
    upsertJsonLd('website', {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      'name': 'FrontPlay',
      'url': url || '',
      'description': description || ''
    });
  }, [title, description, canonical, type, currentLanguage]);

  return null;
}
